<!-- Added 98% width to prevent scroll bar in parent mat-tab -->
<div id="mortgageCalculator" class="singleCalculator" style="width:98%">
    <div class="calc-inner-padded calc-intro">
      <h2>Mortgage Calculator</h2>
      <span class="customizer-text" style="color: rgb(103, 115, 117);">
        {{ mortgageCalcIntro }}
      </span>
    </div>
  
    <div class="calc-inner-padded calc-main">
      <div class="container">
  
        <!-- Home Price Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="HomePrice">Home Price</label>
          </div>
          <div class="col-md-8">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="HomePrice" maxlength="12" [(ngModel)]="homePrice"
                (ngModelChange)="handleHomePriceChange($event)">
            </div>
          </div>
        </div>
  
        <!-- Down Payment Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="DownPaymentDollar">Down Payment</label>
          </div>
          <div class="col-md-5 mb-3">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="DownPaymentDollar" [(ngModel)]="downPaymentDollar"
                (ngModelChange)="handleDownPaymentDollarChange($event)">
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group">
              <input type="number" class="form-control" id="mcDownPaymentPercent" [(ngModel)]="downPaymentPercent"
                (ngModelChange)="handleDownPaymentPercentChange($event)">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
  
        <!-- Loan Program Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="mortgageLoanProgram">Loan Program</label>
          </div>
          <div class="col-md-8">
            <select class="form-control" id="mortgageLoanProgram" [(ngModel)]="loanProgram"
              (ngModelChange)="doCalculation()">
              <option *ngFor="let option of loanProgramOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
  
        <!-- Interest Rate Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="mcInterestRate">Interest Rate</label>
          </div>
          <div class="col-md-8">
            <div class="input-group">
              <input type="number" class="form-control" id="mcInterestRate" [(ngModel)]="interestRate"
                (ngModelChange)="handleInterestRateChange($event)">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
  
        <!-- Property Tax Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="mcPropertyTaxDollar">Property Tax</label>
          </div>
          <div class="col-md-5 mb-3">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="mcPropertyTaxDollar" [(ngModel)]="propertyTaxDollar"
                (ngModelChange)="handlePropertyTaxDollarChange($event)">
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group">
              <input type="number" class="form-control" id="mcPropertyTaxPercent" [(ngModel)]="propertyTaxPercent"
                (ngModelChange)="handlePropertyTaxPercentChange($event)">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
  
        <!-- Homeowners Insurance Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="mcHomeInsurance">Homeowners Insurance</label>
          </div>
          <div class="col-md-8">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="mcHomeInsurance" [(ngModel)]="homeInsurance"
                (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
  
        <!-- HOA Fee Row -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="mcHOA">Homeowners Association</label>
          </div>
          <div class="col-md-8">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="mcHOA" [(ngModel)]="hoa" (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Results Section -->
    <div class="inner-card" style="width: auto; z-index: 1;">
      <div class="calc-inner-padded">
        <div class="row d-flex justify-content-between">
          <div class="col-md-6 col-sm-12">
            <h4>Monthly Payment</h4>
          </div>
          <div class="col-md-6 col-sm-12 justify-content-end">
            <p class="mainResultValue">{{ monthlyPayment | currency }}</p>
          </div>
        </div>
      </div>
  
      <h5>Monthly Calculation Details</h5>
      <table mat-table class="w-100" [dataSource]="fees" >
  
        <!-- Label Column -->
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef> Cost </th>
          <td mat-cell *matCellDef="let element"> {{element.label}} </td>
        </ng-container>
  
        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Amount </th>
          <td mat-cell *matCellDef="let element"> {{element.value | currency}} </td>
        </ng-container>
  
        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- Data Rows -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>